module.exports = __webpack_public_path__ + "static/media/drop-down.f06acfc6.svg";